<bl-page-card-container
  id="guias-com-pacote"
  data-smartpresentation="container-pagina"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <bl-competencia
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>

      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="cdTabelaTussOptions"
          [(ngModel)]="cdTabelaTuss"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onCodigoPacoteChange()"
          [style]="{ width: '220px' }"
          placeholder="Selecione o código do pacote"
          [filter]="true"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        />
      </p-floatlabel>

      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="cdProcedItemOptions"
          [(ngModel)]="cdProcedItem"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onFilterChange()"
          [style]="{ width: '220px' }"
          placeholder="Selecione o cód. procedimento"
          [filter]="true"
          [disabled]="filtrosProcedimentoLoading"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        />
      </p-floatlabel>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      <bl-pesquisar-input class="ml-5 mr-5" (onSearch)="onSearch($event)" [disabled]="!rowData?.length">
      </bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only mr-2"
        (click)="exportExcel()"
        [disabled]="!rowData?.length"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
      >
        <i class="pi pi-file-excel"></i>
      </button>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        ></i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full h-full"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [style.height]="gridHeight$ | async"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>

      <div class="grid-footer">
        <small>Último processamento em: {{ dtUltimoProcessamento || '-' }}</small>
      </div>
    </div>

    <div class="pagination-container flex justify-content-center mt-3">
      <bl-pagination
        [data]="rowData"
        [total]="rowTotal"
        [(page)]="page"
        [(size)]="pageSize"
        [(reset)]="paginationReset"
        (onChange)="onPageChange($event)"
      >
      </bl-pagination>
    </div>
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
>
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Detalhes da guia/lançamento</h5>
      <div class="p-dialog-header-icons mr-2">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-primary p-button-sm p-button-text p-dialog-header-icon"
          (click)="showDetalheGuiaForPrev()"
          [disabled]="detalheGuiaCodigoIndex <= 0"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-primary p-button-sm p-button-text p-dialog-header-icon"
          (click)="showDetalheGuiaForNext()"
          [disabled]="detalheGuiaCodigoIndex > guiasList.length - 2"
        ></button>
      </div>
    </div>
  </ng-template>

  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>